import { render, staticRenderFns } from "./PlanejamentoClassificacao.vue?vue&type=template&id=0ac6c281&scoped=true"
import script from "./PlanejamentoClassificacao.vue?vue&type=script&lang=js"
export * from "./PlanejamentoClassificacao.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoClassificacao.vue?vue&type=style&index=0&id=0ac6c281&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac6c281",
  null
  
)

export default component.exports